import React, { ReactElement, Suspense } from 'react';
import { Global } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router';
import i18n from 'translations/i18n';
import { queryClient } from 'common/clients/query.client';
import { App as AntApp } from 'common/components/antd/App';
import { Loader } from 'common/components/Loader/Loader';
import routerTree from 'navigation/routerTree';
import { globalStyles } from 'theme/global.styles';
import { themeConfigProvider } from 'theme/theme.config';

const App = (): ReactElement => (
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <QueryClientProvider client={queryClient}>
        <Global styles={globalStyles} />
        <ConfigProvider theme={themeConfigProvider}>
          <I18nextProvider i18n={i18n}>
            <AntApp>
              <RouterProvider router={routerTree} />
            </AntApp>
          </I18nextProvider>
          <ReactQueryDevtools position="right" />
        </ConfigProvider>
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>
);

export default App;
